import { defineStore } from 'pinia'
import type { OneNetworkMenuGroupItem } from '@/onenetwork/interfaces/onenetwork.interface.menu'
import OneNetworkConfig from '@/onenetwork/core/onenetwork.config'

const baseRoute = OneNetworkConfig.baseRoutePath

export const useOneNetworkMenuStore = defineStore('onenetwork.menu', {
  state: (): { items: OneNetworkMenuGroupItem[]; collapsed: string[]; openMenu: boolean } => ({
    items: [
      {
        heading: '',
        perm: '*',
        items: [
          {
            name: 'Tổng quan',
            path: `${baseRoute}/overview`,
            icon: 'mage:dashboard-chart-arrow-fill',
          },
        ],
      },
      {
        heading: 'Quản lý tài khoản',
        perm: [
          'account.approve_kyc',
          'account.edit_info',
          'account.list_acc',
          'account.delete_acc',
          'account.view_kyc',
          'account.view_membershop',
          'account.deposit',
          'account.edit_bo_detail',
          'account.view_wallet',
          'account.view_transaction',
          'account.view_bo_detail',
          'account.create_bo',
          'account.delete_bo',
          'account.list_kyc',
          'account.edit_bo_perms',
          'account.list_bo',
          'account.withdraw',
          'account.edit_membershop',
          'account.edit_kyc',
          'account.view_info',
        ],
        items: [
          {
            name: 'Quản lý đăng ký',
            path: `${baseRoute}/account/list`,
            icon: 'tdesign:member',
            perm: ['account.list_acc'],
          },
          // { name: 'Phê duyệt KYC', path: `${baseRoute}/account/kyc`, icon: 'bitcoin-icons:verify-filled', perm: ['account.approve_kyc', 'account.list_kyc']},
          {
            name: 'Tài khoản BO',
            path: `${baseRoute}/account/bo`,
            icon: 'clarity:id-badge-solid',
            perm: ['account.list_bo'],
          },
        ],
      },
      {
        heading: 'Quản lý giao dịch & ví',
        perm: ['transaction.deposit', 'transaction.withdraw', 'transaction.list'],
        items: [
          {
            name: 'Nạp tiền',
            path: `${baseRoute}/transaction/deposit`,
            icon: 'hugeicons:money-receive-circle',
            perm: ['transaction.deposit'],
          },
          {
            name: 'Yêu cầu rút tiền',
            path: `${baseRoute}/transaction/withdraw`,
            icon: 'hugeicons:money-send-circle',
            perm: ['transaction.withdraw'],
          },
          {
            name: 'Lịch sử giao dịch',
            path: `${baseRoute}/transaction/history`,
            icon: 'qlementine-icons:money-16',
            perm: ['transaction.list'],
          },
        ],
      },
      {
        heading: 'Quản lý môi giới',
        perm: [
          'broker.approve',
          'broker.list',
          'broker.view_info',
          'broker.edit_info',
          'broker.eval',
        ],
        items: [
          {
            name: 'Phê duyệt đăng ký',
            path: `${baseRoute}/broker/approval`,
            icon: 'tdesign:verify-filled',
            perm: ['broker.approve'],
          },
          {
            name: 'Danh sách môi giới',
            path: `${baseRoute}/broker/list`,
            icon: 'map:travel-agency',
            perm: ['broker.list'],
          },
        ],
      },
      {
        heading: 'Quản lý BDS',
        perm: [
          'real_estate.list',
          'real_estate.approve',
          'real_estate.edit',
          'real_estate.view_consumer',
          'real_estate.view_contract',
        ],
        items: [
          {
            name: 'Dự án bất động sản',
            path: `${baseRoute}/property/projects`,
            icon: 'icon-park-solid:building-one',
            perm: ['real_estate.list'],
          },
          {
            name: 'Danh sách tài sản',
            path: `${baseRoute}/property/items`,
            icon: 'lucide:land-plot',
            perm: ['real_estate.list'],
          },
          {
            name: 'Phê duyệt tin đăng',
            path: `${baseRoute}/property/approval`,
            icon: 'lucide:check-circle',
            perm: ['real_estate.approve_list'],
          },
          {
            name: 'Danh sách tin đăng',
            path: `${baseRoute}/property/listings`,
            icon: 'lucide:list-check',
            perm: ['real_estate.list'],
          },

          {
            name: 'Tra cứu yêu cầu tư vấn',
            path: `${baseRoute}/consultations/list`,
            icon: 'material-symbols:contact-support-outline-rounded',
            perm: ['real_estate.view_consumer'],
          },
        ],
      },
      {
        heading: 'Quản lý FlashOffer',
        perm: [
          'flash_offer.list',
          'flash_offer.create_flash_offer',
          'flash_offer.view_flash_offer',
          'flash_offer.stop_flash_offer',
          'flash_offer.view_flash_offer_result',
        ],
        items: [
          {
            name: 'Danh sách FlashOffer',
            path: `${baseRoute}/flash-offer/list`,
            icon: 'fluent:flash-sparkle-16-filled',
            perm: ['flash_offer.list'],
          },
          {
            name: 'Kết quả chốt deal',
            path: `${baseRoute}/flash-offer/results`,
            icon: 'fluent:flash-checkmark-16-filled',
            perm: ['flash_offer.view_flash_offer_result'],
          },
        ],
      },
      {
        heading: 'Quản lý hợp đồng & giao dịch',
        perm: [
          'contract.list',
          'contract.approve',
          'contract.edit',
          'contract.view_consumer',
          'contract.view_contract',
        ],
        items: [
          {
            name: 'Quản lý hợp đồng',
            path: `${baseRoute}/contracts/list`,
            icon: 'clarity:contract-line',
            perm: ['contract.list'],
          },
          {
            name: 'Quản lý hoa hồng',
            path: `${baseRoute}/commission/list`,
            icon: 'hugeicons:save-money-dollar',
            perm: ['contract.list'],
          },
        ],
      },
      // { heading: 'Dịch vụ liên kết', perm: ['linked_service.list', 'linked_service.approve', 'linked_service.edit', 'linked_service.view_consumer', 'linked_service.view_contract'], items: [
      //   { name: 'Quản lý dịch vụ liên kết', path: `${baseRoute}/services/list`, icon: 'ri:links-line', perm: ['linked_service.list']},
      // ]},
      // { heading: 'Báo cáo & thống kê', perm: ['report.usage', 'report.transactions', 'report.broker_commissions'], items: [
      //   { name: 'Thống kê sử dụng app', path: `${baseRoute}/reports/usage`, icon: 'mdi:chart-arc', perm: ['report.usage']},
      //   { name: 'Thống kê giao dịch', path: `${baseRoute}/reports/transactions`, icon: 'mdi:chart-arc', perm: ['report.transactions']},
      //   // { name: 'Thống kê khách hàng', path: `${baseRoute}/reports/customers`, icon: 'mdi:chart-arc'},
      //   { name: 'Thống kê hoa hồng', path: `${baseRoute}/reports/broker-commissions`, icon: 'mdi:chart-arc', perm: ['report.broker_commissions']},
      // ]},
      // { heading: 'CSKH', perm: ['cs.bulk_message', 'cs.popup'], items: [
      //   { name: 'Gửi tin hàng loạt', path: `${baseRoute}/cs/bulk-messages`, icon: 'mingcute:announcement-fill', perm: ['cs.bulk_message']},
      //   { name: 'Quản lý poup', path: `${baseRoute}/cs/popup`, icon: 'vaadin:modal', perm: ['cs.popup']},
      // ]},
      // { heading: 'Quản lý hệ thống', perm: ['setting.view_version', 'setting.add_version', 'setting.edit_version', 'setting.view_mbs_plan', 'setting.add_mbs_plan', 'setting.edit_mbs_plan'], items: [
      //   // { name: 'Cấu hình ứng dụng', path: `${baseRoute}/system/configuration`, icon: 'ic:round-app-settings-alt'},
      //   { name: 'Cấu hình phiên bản', path: `${baseRoute}/system/version`, icon: 'qlementine-icons:version-control-16', perm: ['setting.view_version']},
      //   { name: 'Cấu hình các gói hội viên', path: `${baseRoute}/system/memberships`, icon: 'mdi:medal', perm: ['setting.view_mbs_plan']},
      // ]},
      {
        heading: 'Quản lý nội bộ',
        perm: ['attendance.attendance_view', 'attendance.attendance_edit'],
        items: [
          {
            name: 'Quản lý chấm công',
            path: `${baseRoute}/backoffice/attendance`,
            icon: 'bxs:user-check',
            perm: ['attendance.attendance_view'],
          },
        ],
      },
      {
        heading: 'CSKH',
        perm: '*',
        items: [
          {
            name: 'Chiến dịch thông báo đẩy',
            path: `${baseRoute}/push-campaign/list`,
            icon: 'streamline:send-email-solid',
            perm: '*',
          },
        ],
      },
    ],
    collapsed: [],
    openMenu: true,
  }),
  persist: false,
  actions: {
    toggleCollapsed(heading: string) {
      if (this.collapsed.includes(heading)) {
        this.collapsed = this.collapsed.filter((h) => h !== heading)
      } else {
        this.collapsed.push(heading)
      }
    },
    toggleOpenMenu() {
      this.openMenu = !this.openMenu
    },
  },
})
